import { setCurrentUser } from "../reducers/users";
import { store } from "../store/store";
import axios from "axios";

const {
  REGISTER_API_ROUTE,
  LOGIN_API_ROUTE,
  LOGOUT_API_ROUTE,
} = require("../../routes/api/api_routes");

const users = {
  registerUser(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(REGISTER_API_ROUTE, data)
        .then((response) => {
          console.log(response);
          if (response.status === 201) {
            let user = response.data;
            resolve(user);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  loginUser(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(LOGIN_API_ROUTE, data)
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            let user = response.data;
            let dispatch = store.dispatch;
            dispatch(setCurrentUser(user));
            localStorage.setItem("currentUser", JSON.stringify(user));
            resolve(user);
          } else {
            reject(response);
          }
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  logout(token) {
    return new Promise((resolve, reject) => {
      axios
        .post(LOGOUT_API_ROUTE, "", {
          headers: { Authorization: "Bearer " + token },
        })
        .then((response) => {
          console.log(response);
          let dispatch = store.dispatch;
          dispatch(setCurrentUser({}));
          resolve(response);
        })
        .catch((err) => {
          let dispatch = store.dispatch;
          dispatch(setCurrentUser({}));
          console.log(err);
          reject(err);
        });
    });
  },
};

// 🛠️ Correction : ajout de la méthode en-dehors de l'objet
users.getCurrentUser = () => {
  const data = localStorage.getItem("currentUser");
  return data ? JSON.parse(data) : null;
};

export default users;
